import GenericTableFilter from '../../../components/common/GenericTableFilter';

const ApprovalOrdersFilter = ({ filterFields, handleApplyFilters, handleResetFilters }) => {
    return (
        <div className="mb-2">
            <GenericTableFilter
                filterFields={filterFields}
                initialFilters={{}}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
            />
        </div>
    );
};

export default ApprovalOrdersFilter;
